import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {getAuth} from 'firebase/auth';
import DeviceSettings from '../components/settings/DeviceSettings';
import EdgeAccessKey from '../components/settings/EdgeAccessKey';
import EdgeVersionInfo from '../components/settings/EdgeVersionInfo';
import Lifecycle from '../components/settings/Lifecycle';
import Notifications from '../components/settings/Notifications';
import RebootDevice from '../components/settings/RebootDevice';
import Recycle from '@mui/icons-material/AutorenewRounded';
import InfoCircle from '@mui/icons-material/InfoRounded';
import MemoryIcon from '@mui/icons-material/MemoryRounded';

const SettingsPage = () => {
  const {eid} = useParams();
  const [nodeRedAdmin, setNodeRedAdmin] = useState(false);
  const [lifecycleManagement, setLifecycleManagement] = useState(false);
  useEffect(() => {
    getAuth().currentUser.getIdTokenResult().then((idTokenResult) => {
      setNodeRedAdmin(idTokenResult?.claims?.nodeRedAdmin);
      setLifecycleManagement(idTokenResult?.claims?.lifecycleManagement);
    });
  }, []);
  return (
    <div className="p-3">
      <div className="row g-4 mb-4">
        {lifecycleManagement && (
          <div className="col-lg-7 d-flex flex-column">
            <h5 className="mb-3" style={{color: 'var(--text-primary)'}}>
              <Recycle className="me-2" style={{marginBottom: 3, fontSize: 20}}/>Lifecycle
            </h5>
            <Lifecycle eid={eid}/>
          </div>
        )}
        <div className={`d-flex flex-column ${lifecycleManagement ? 'col-lg-5' : 'col-12'}`}>
          <h5 className="mb-3" style={{color: 'var(--text-primary)'}}>
            <MemoryIcon className="me-2" style={{marginBottom: 3, fontSize: 20}}/>Core Version
          </h5>
          <EdgeVersionInfo eid={eid}/>
        </div>
      </div>
      <section className="mt-4">
        <div className="row g-4">
          <div className="col-lg-6 d-flex flex-column">
            <h5 className="mb-3" style={{color: 'var(--text-primary)'}}>
              Notifications
            </h5>
            <Notifications eid={eid}/>
          </div>
          <div className="col-lg-6 d-flex flex-column">
            <h5 className="mb-3" style={{color: 'var(--text-primary)'}}>
              Current Transformers
            </h5>
            <DeviceSettings eid={eid}/>
          </div>
        </div>
      </section>
      <section className="mt-4">
        <RebootDevice eid={eid}/>
      </section>
      <section className="mt-4">
        <EdgeAccessKey eid={eid}/>
      </section>
    </div>
  );
};
export default SettingsPage;
